/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Delete_Error_DescriptionInputs */

const es_admin_users_delete_error_description = /** @type {(inputs: Admin_Users_Delete_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocurrió un error al eliminar el usuario. Intentá nuevamente.`)
};

const en_admin_users_delete_error_description = /** @type {(inputs: Admin_Users_Delete_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred while deleting the user. Please try again.`)
};

/**
* | output |
* | --- |
* | "An error occurred while deleting the user. Please try again." |
*
* @param {Admin_Users_Delete_Error_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_delete_error_description = /** @type {((inputs?: Admin_Users_Delete_Error_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Delete_Error_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_delete_error_description(inputs)
	return en_admin_users_delete_error_description(inputs)
});
export { admin_users_delete_error_description as "admin.users.delete.error.description" }